<mat-form-field
  appearance="fill"
  floatLabel="always"
  subscriptSizing="dynamic"
  [ngClass]="{
    'rkt-FormField--full-width': isFullWidth
  }"
  >
  <mat-label [attr.data-testid]="dataTestId + '-label'">{{ label }}</mat-label>
  @if (!!formControlRef) {
    <mat-select
      [disableRipple]="true"
      [hideSingleSelectionIndicator]="true"
      [attr.autocomplete]="autocomplete"
      [attr.data-testid]="dataTestId"
      [formControl]="formControlRef"
      [placeholder]="placeholder"
      (selectionChange)="handleSelectionChange($event)"
      panelClass="rkt-SelectPanel"
      >
      @for (option of options; track option) {
        <mat-option
          data-private
          [value]="option.value"
          [disabled]="option.disabled"
          >{{ option.label }}
          </mat-option
          >
        }
      </mat-select>
    } @else {
      <mat-select
        [disableRipple]="true"
        [hideSingleSelectionIndicator]="true"
        [attr.autocomplete]="autocomplete"
        [attr.data-testid]="dataTestId"
        [disabled]="isDisabled"
        [placeholder]="placeholder"
        [value]="value"
        (selectionChange)="handleSelectionChange($event)"
        panelClass="rkt-SelectPanel"
        >
        @for (option of options; track option) {
          <mat-option
            data-private
            [value]="option.value"
            [disabled]="option.disabled"
            >{{ option.label }}
            </mat-option
            >
          }
        </mat-select>
      }
      <mat-error [attr.data-testid]="dataTestId + '-error'">{{ errorMessage }}</mat-error>
    </mat-form-field>
